import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as Cx from 'classnames';

import { locations, LocationTopic, LocationEntry, LocationArea } from '../data/location';

import './location.css';

const locationBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/location_background.jpg'})`,
};

interface LocationMatchParams {
  area: keyof LocationArea;
}

export default class LocationPage extends React.PureComponent<RouteComponentProps<LocationMatchParams>, {}> {
  get currentArea(): LocationArea | undefined {
    if (!this.props.match.params.area) {
      return undefined;
    }

    return LocationArea[this.props.match.params.area];
  }

  locationTopic = (topic: LocationTopic): JSX.Element => {
    return (
      <li key={topic.topic} className="location-topic">
        <h2 className="title is-4 is-shadowed">{topic.topic}</h2>
        <ul>{topic.entries.map(this.locationEntry)}</ul>
      </li>
    );
  };

  locationEntry = (entry: LocationEntry): JSX.Element | undefined => {
    if (this.currentArea && entry.area.indexOf(this.currentArea) < 0) {
      return undefined;
    }

    return (
      <li key={entry.location}>
        <dt>
          {entry.href ? (
            <a href={entry.href} target="_blank" rel="noopener">
              {entry.location}
            </a>
          ) : (
            entry.location
          )}
        </dt>
        <dd>{entry.note}</dd>
      </li>
    );
  };

  get filters(): JSX.Element {
    return (
      <div className="buttons">
        <Link to="/location" className={Cx({ button: true, all: true, 'is-active': !this.currentArea })}>
          All
        </Link>
        {Object.keys(LocationArea).map(path => {
          const area = LocationArea[path];
          return (
            <Link
              key={path}
              to={`/location/${path}`}
              className={Cx({ button: true, 'is-active': this.currentArea === area })}
            >
              {area}
            </Link>
          );
        })}
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <section className="location section background escape-nav" style={locationBackground}>
        <div className="container">
          <h1 className="title is-shadowed has-text-centered">Fun things in Oahu</h1>
          {this.filters}
          <div className="content">
            <ul>{locations.map(this.locationTopic)}</ul>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/location.tsx